<template>
<div class="form-container" :style="{
      padding: '0px',
      background: '#fff',
      height: '100%'
    }">
  <flex-row style="background: #fff;width:100%">
    <flex-col style="
            width: 50%;
            align-items: center;
            background: #fff;
            justify-content: center;
          ">
      <eco-avatar v-if="userInfo.avatar" :size="80" :user="userInfo" />
      <p style="
              font-size: 14px;
              color: #222;
              margin-top: 18px;
              line-height: 20px;
            ">
        图片尺寸80*80px
      </p>
      <p style="font-size: 12px; color: #777; line-height: 20px">
        支持.png.jpg.jpeg.svg等格式，大小不超过2M
      </p>
      <span style="margin-top: 24px">
        <a-upload name="file" width="100%" :multiple="false" :headers="headers" accept=".jpg,.jpeg,.png" :beforeUpload="(file) => beforeImgUpload(file)" :action="'/eco-file-server/file/eco/upload/img/user-image'" :showUploadList="false" @change="({ file }) => handleFileChange(file)">
          <!-- <a-button class="btn-sm-line-gray">上传头像</a-button> -->
          <a-button style="height:36px;width:120px">上传头像</a-button>
        </a-upload>
      </span>
    </flex-col>
    <flex-col style="justify-content:center;">
      <div style="height:156px;border-right: 1px dashed #CFD4E2;"></div>
    </flex-col>
    <flex-col class="right-container" :style="{
            paddingLeft: '40px',
            justifyContent: 'center'
          }">
      <a-form-model labelAlign="left" :style="{ maxWidth: '680px', fontSize: '16px' }" :model="userInfo" :rules="rules" ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="昵称" prop="nickname">
          <a-input v-model.trim="userInfo.nickname" placeholder="" type="nickname" />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false">
          <a-button type="primary" style="height:36px;width:100px" :disabled="isSave" @click="save()">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </flex-col>
  </flex-row>
</div>
</template>

<script>
import {
  verifyRealName,
  editUserInfo
} from "@/request/user";
import {updateInfo} from '../../App.vue'
import {
  user,
  model
} from "eco-cli";
const {
  getToken,
  login,
  getInfo,
  setToken
} = user
const Image = model.Image;
const User = model.UserInfo;

export default {
  components: {},
  props: [],
  mixins: [],
  computed: {
    rules() {
      return {
        nickname: [{
            required: true,
            message: "请输入昵称！",
            trigger: "change",
          },
          {
            min: 2,
            max: 10,
            message: "长度为2—10",
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              this.validateRealName(rule, value, callback);
            },
            trigger: "change",
          },
        ],
      };
    },
  },

  data() {
    return {
      userInfo: {
        nickname: ""
      },
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 18
      },
      headers: {},
      type: "selectable",
      token: '',
      isSave: false
    };
  },
  // beforeCreate() {
  //   document.querySelector("body").setAttribute("style", "overflow-y:auto");
  // },
  // beforeDestroy() {
  //   document.body.removeAttribute("style");
  // },
  mounted() {
    getToken().then((res) => {
      this.token = res;
      this.headers = {
        "X-Access-Token": res
      };
    })
    getInfo(true).then(res => {
      console.log("currentUser", res)
      this.userInfo = res;
    });
  },
  methods: {
    handleFileChange(file) {
      if (file.status === "done") {
        if (file.response.success) {
          this.userInfo.avatar = Image.avatar(file.response.result.id);
          console.log("avatar", this.userInfo.avatar)
          // 头像上传成功后保存
          editUserInfo({
              avatar: this.userInfo.avatar.fileId,
            })
            .then((res) => {
              this.$message.success("保存成功！");
              this.userInfo.avatar.fileId = res.avatar
              setToken(this.token, this.userInfo);
              updateInfo()
            })
          this.$message.success(`${file.name} 文件上传成功`);
        } else {
          this.$message.error(file.response.message);
        }
      } else if (file.status === "error") {
        this.$message.error(`${file.name} 文件上传失败`);
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSave = true;
          editUserInfo({
              nickname: this.userInfo.nickname
            })
            .then((res) => {
              this.$message.success("保存成功！");
              this.userInfo.nickname = res.nickname;
              setToken(this.token, this.userInfo);
              updateInfo()
            })
            .finally(() => {
              this.isSave = false;
            })
        } else {
          return false;
        }
      });
    },
    beforeImgUpload(file) {
      const fileType = file.type;
      if (fileType.indexOf("image") < 0) {
        this.$message.warning("请上传.png.jpg.jpeg.svg等格式图片!");
        return false;
      }
      const isTooLarge = file.size / 1024 / 1024 > 2;
      if (isTooLarge) {
        this.$message.error("单个图片不能超过2MB!");
        return false;
      }
      return true;
    },
    // 验证重命名
    validateRealName(rule, value, callback) {
      let timer = null;
      var that = this;
      return (function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
          that.checkName(rule, value, callback);
        }, 300);
      })();
    },
    checkName(rule, value, callback) {
      if (!value || value.length < 2 || value.length > 10) {
        return;
      }
      verifyRealName(value).then((res) => {
        if (res) {
          callback(new Error("昵称已被占用，请更换其它昵称"));
        } else {
          callback();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container ::v-deep .ant-form label {
  font-size: 16px !important;
}

.form-container {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.right-container {
  width: 50%;
}
</style>
